import './main-loader.scss';

interface IProps {
  fullWidth?: boolean;
  fullScreen?: boolean;
  fontSize?: number;
}

const MainLoader: React.FC<IProps> = ({
  fullWidth,
  fullScreen,
  fontSize = 48
}) => {
  const rootClasses = [
    'main-loader',
    fullWidth ? 'main-loader--full-width' : '',
    fullScreen ? 'main-loader--fullscreen' : ''
  ].join(' ');

  return (
    <div className={rootClasses}>
      <div className="main-loader__text" style={{ fontSize }}>
        <span>Leasing</span>
      </div>
    </div>
  );
};

export default MainLoader;
